import React from 'react';
import { connect } from 'react-redux';
import { resend } from '../actions/user';
import logo from '../assets/images/image_fitgames_logo.png';
import * as R from 'ramda';
import { message } from 'antd';

class VerifyResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }

        this.handleOnResendSubmit = this.handleOnResendSubmit.bind(this);
        this.handleOnResetSubmit = this.handleOnResetSubmit.bind(this);
        this.handleOnResetMenu = this.handleOnResetMenu.bind(this);
        this.handleOnSignup = this.handleOnSignup.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.handleLoginMenu = this.handleLoginMenu.bind(this);
    }

    componentDidUpdate(prevProps) {

        if (R.isEmpty(prevProps.response.data)) {
            if (this.props.response.data.status === 'success') {

            } else if (this.props.response.data.status === 'fail') {
                const response = this.props.response.data.response;
                const { errors } = response.data;

                const msg = errors === undefined ? '更新失敗' : errors.message;
                message.error(msg);
            }
        }

    }

    handleOnSubmit(values) {
        this.props.login(values);
    }

    handleOnSignup(values) {
        this.props.signup(values);
    }

    handleOnResetSubmit(values) {
        this.props.resetPassword(values);
    }

    handleOnResendSubmit(values) {
        this.props.resend(values);
    }

    render() {
        return (
            <div className="flex-center-center" style={{ height: '100vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <img src={logo} alt="fitCloud" style={{ width: '40%' }} />

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    response: state.user.submitResponse,
    isSubmitting: state.user.submitResponse.isSubmitting,
    isLogged: state.user.isLogged,
    me: state.user.me,
});

const mapDispatchToProps = {
    resend,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VerifyResult);
